/* eslint-disable */
/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { useState, useContext, useEffect } from "react";
import "./index.css";
import MyContext from "../../components/Mycontext";
import logo from "../../../static/logo.png";
import { useNavigate, useParams } from "react-router-dom";

import Frame from "../../../static/icon/Frame.svg";
import lightFrame from "../../../static/light-icon/Frame.svg";
import GroupDay from "../../../static/icon/Group-day.png";
import GroupNight from "../../../static/icon/Group-night.svg";
import message from "../../../static/icon/message.svg";
import lightMessage from "../../../static/light-icon/message.svg";
import deleteSvg from "../../../static/icon/delete.svg";
import lightDeleteSvg from "../../../static/light-icon/delete.svg";
import cardIcon from "../../../static/icon/card.svg";
import lightCardIcon from "../../../static/light-icon/card.svg";
import openboxIcon from "../../../static/icon/openbox.svg";
import lightOpenboxIcon from "../../../static/light-icon/lightopenbox.svg";
// import cnlogo from "../../../static/cn_logo.png";
import cnlogo from "../../../static/cn_logo2.png";
import { Image, Spinner } from "react-bootstrap";

import { CN_TEXT, US_TEXT } from "../../../config";
import { useTranslation } from "react-i18next";
import { useTheme } from "../../../providers/CustomThemeProvider";
import { LogoutOutlined, MoonOutlined, SunOutlined } from "@ant-design/icons";
import { Switch } from "antd";
import eventBus from "../../../eventBus";

interface IProps {
	onHideSide: () => void;
	hideSide: boolean;
	recordList: any;
	setRecordList: any;
}

function DoctaAiRecord(props: IProps) {
	const { t, i18n } = useTranslation();
	const { onHideSide, hideSide, recordList, setRecordList } = props;
	const { id } = useParams<{ id: string }>(); // 获取 id 参数
	const { isDarkMode, switchTheme } = useTheme();

	const navigate = useNavigate();
	const [sideClosed, setSideClosed] = useState(hideSide ? "closed" : "open");

	const context = useContext(MyContext);

	if (!context) {
		return null; // 处理无法获取到 Context 的情况
	}

	useEffect(() => {
		setSideClosed(hideSide ? "closed" : "open");
	}, [hideSide]);

	const {
		setSelectedChat,
		conversationId,
		setConversationId,
		setIsLoad,
		setIsInputValue,
		seleConversation,
		deleItem,
		addSession,
		setCurrent,
	} = context;

	return (
		<div className={`doctaRecord ${sideClosed}`}>
			<div className="docta-ai-head">
				<div
					className="docta-ai-label"
					onClick={() => {
						navigate("/");
					}}
				>
					{i18n.language == "en" ? (
						<Image src={logo} />
					) : (
						<Image src={cnlogo} style={{ width: 140 }} />
					)}
				</div>
				<div
					className="hideside-icon"
					onClick={() => {
						onHideSide();
						setSideClosed("closed");
					}}
				>
					<Image src={isDarkMode ? openboxIcon : lightOpenboxIcon} />
				</div>
			</div>
			<div
				className="docta-ai-new-chat"
				onClick={() => {
					navigate("/d5data");
					addSession();
				}}
			>
				<Image src={isDarkMode ? Frame : lightFrame} />
				<span>{i18n.language == "en" ? US_TEXT.NEWCHAT : CN_TEXT.NEWCHAT}</span>
			</div>

			<div className="doctaRecord-list scroll-bar-style hidden-scrollbar">
				<div className="doctaRecord-list-title">
					<span>{i18n.language == "en" ? US_TEXT.RECENT : CN_TEXT.RECENT}</span>
				</div>

				<div className="doctaRecord-list-inner  hidden-scrollbar">
					{recordList.map((item: any) => (
						<div
							className={`doctaRecord-list-item ${
								conversationId == item.id && "doctaRecord-list-item-sele"
							}`}
							key={item.id}
							onClick={() => {
								setCurrent([]);
								seleConversation(item.id);
							}}
						>
							{/* <Image
							src={isDarkMode ? message : lightMessage}
							className="doctaRecord-list-item-image"
						/> */}
							<div className="doctaRecord-list-item-text">{item.title}</div>
							<Image
								src={isDarkMode ? deleteSvg : lightDeleteSvg}
								onClick={(e) => {
									e.stopPropagation();
									deleItem(item.id);
								}}
							/>
						</div>
					))}
				</div>

				<div className="doctaRecord-footer">
					<div className="action-wrapper">
						<div
							className="logout"
							onClick={() => {
								eventBus.emit("force-logout");
								navigate("/login");
							}}
						>
							<LogoutOutlined />
							{t("op.logout")}
						</div>

						<div className="theme-switch">
							<Switch
								checkedChildren={<MoonOutlined />}
								unCheckedChildren={<SunOutlined />}
								checked={isDarkMode}
								onChange={switchTheme}
								className="custom-switch"
							/>
							{isDarkMode ? "深色模式" : "浅色模式"}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

export default DoctaAiRecord;
